import { createSlice } from '@reduxjs/toolkit';
import {
  fetchEndWallStageOneForm,
  fetchEndWallStageTwoForm,
  fetchEndWallStageOneData,
  addEndWallStageOneData,
  addEndWallStageTwoData,
  fetchEndWallStageTwoData,
  fetchEwFrameNumber,
  fetchEwDrawingNumber,
  fetchViewEwStageOneData,
  fetchViewEwStageTwoData,
  fetchEndWallFlowHistory,
  endWallActionStageOne,
  fetchEwMasterNumbers,
  fetchNewEndWallFlowHistory,
} from './endWallThunk';

const initialState = {
  endWallStageOne: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  endWallStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  endWallStageOneData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },
  addEndWallStageOneData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  addEndWallStageTwoData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getEndWallStageTwoData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },

  getEndWallFrameNumber: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getEndWallDrawingNumber: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewStageOneData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  viewStageTwoData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  flowHistory: [],
  getMasterEwNo: {
    loading: false,
    error: null,
    ew_nos: [],
  },
  flowEndWallHistory: [],
};

const endWallSlice = createSlice({
  name: 'endWall',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEndWallStageOneForm.pending, (state) => {
        state.endWallStageOne.loading = true;
        state.endWallStageOne.error = null;
      })
      .addCase(fetchEndWallStageOneForm.fulfilled, (state, action) => {
        state.endWallStageOne.loading = false;
        state.endWallStageOne.data = action.payload;
      })
      .addCase(fetchEndWallStageOneForm.rejected, (state, action) => {
        state.endWallStageOne.loading = false;
        state.endWallStageOne.error = action.payload || 'Failed to fetch materials';
      })
      .addCase(fetchEndWallStageTwoForm.pending, (state) => {
        state.endWallStageTwo.loading = true;
        state.endWallStageTwo.error = null;
      })
      .addCase(fetchEndWallStageTwoForm.fulfilled, (state, action) => {
        state.endWallStageTwo.loading = false;
        state.endWallStageTwo.data = action.payload;
      })
      .addCase(fetchEndWallStageTwoForm.rejected, (state, action) => {
        state.endWallStageTwo.loading = false;
        state.endWallStageTwo.error = action.payload || 'Failed to fetch materials';
      })
      .addCase(fetchEndWallStageOneData.pending, (state) => {
        state.endWallStageOneData.loading = true;
        state.endWallStageOneData.error = null;
      })
      .addCase(fetchEndWallStageOneData.fulfilled, (state, action) => {
        state.endWallStageOneData.loading = false;
        state.endWallStageOneData.data = action.payload.data;
        state.endWallStageOneData.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.total_pages || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchEndWallStageOneData.rejected, (state, action) => {
        state.endWallStageOneData.loading = false;
        state.endWallStageOneData.error =
          action.payload || 'Failed to fetch end wall stage one data';
      })
      .addCase(addEndWallStageOneData.pending, (state) => {
        state.addEndWallStageOneData.loading = true;
        state.addEndWallStageOneData.error = null;
      })
      .addCase(addEndWallStageOneData.fulfilled, (state, action) => {
        state.addEndWallStageOneData.loading = false;
        state.addEndWallStageOneData.data = action.payload.data;
      })
      .addCase(addEndWallStageOneData.rejected, (state, action) => {
        state.addEndWallStageOneData.loading = false;
        state.addEndWallStageOneData.error =
          action.payload || 'Failed to fetch end wall stage one data';
      })
      .addCase(addEndWallStageTwoData.pending, (state) => {
        state.addEndWallStageTwoData.loading = true;
        state.addEndWallStageTwoData.error = null;
      })
      .addCase(addEndWallStageTwoData.fulfilled, (state, action) => {
        state.addEndWallStageTwoData.loading = false;
        state.addEndWallStageTwoData.data = action.payload.data;
      })
      .addCase(addEndWallStageTwoData.rejected, (state, action) => {
        state.addEndWallStageTwoData.loading = false;
        state.addEndWallStageTwoData.error =
          action.payload || 'Failed to fetch end wall stage one data';
      })
      .addCase(fetchEndWallStageTwoData.pending, (state) => {
        state.getEndWallStageTwoData.loading = true;
        state.getEndWallStageTwoData.error = null;
      })
      .addCase(fetchEndWallStageTwoData.fulfilled, (state, action) => {
        state.getEndWallStageTwoData.loading = false;
        state.getEndWallStageTwoData.data = action.payload.data;
        state.getEndWallStageTwoData.pagination = {
          currentPage: action.payload?.current_page || 1,
          totalPages: action.payload?.total_pages || 1,
          totalItems: action.payload?.total || 0,
          perPage: action.payload?.per_page || 10,
        };
      })
      .addCase(fetchEndWallStageTwoData.rejected, (state, action) => {
        state.getEndWallStageTwoData.loading = false;
        state.getEndWallStageTwoData.error =
          action.payload || 'Failed to fetch end wall stage one data';
      })

      .addCase(fetchEwFrameNumber.pending, (state) => {
        state.getEndWallFrameNumber.loading = true;
        state.getEndWallFrameNumber.error = null;
      })
      .addCase(fetchEwFrameNumber.fulfilled, (state, action) => {
        state.getEndWallFrameNumber.loading = false;
        state.getEndWallFrameNumber.data = action.payload.data;
      })
      .addCase(fetchEwFrameNumber.rejected, (state, action) => {
        state.getEndWallFrameNumber.loading = false;
        state.getEndWallFrameNumber.error =
          action.payload || 'Failed to fetch end wall frame number';
      })

      .addCase(fetchEwDrawingNumber.pending, (state) => {
        state.getEndWallDrawingNumber.loading = true;
        state.getEndWallDrawingNumber.error = null;
      })
      .addCase(fetchEwDrawingNumber.fulfilled, (state, action) => {
        state.getEndWallDrawingNumber.loading = false;
        state.getEndWallDrawingNumber.data = action.payload.data;
      })
      .addCase(fetchEwDrawingNumber.rejected, (state, action) => {
        state.getEndWallDrawingNumber.loading = false;
        state.getEndWallDrawingNumber.error =
          action.payload || 'Failed to fetch end wall drawing number';
      })

      .addCase(fetchViewEwStageOneData.pending, (state) => {
        state.viewStageOneData.loading = true;
        state.viewStageOneData.error = null;
      })
      .addCase(fetchViewEwStageOneData.fulfilled, (state, action) => {
        state.viewStageOneData.loading = false;
        state.viewStageOneData.data = action.payload.data;
      })
      .addCase(fetchViewEwStageOneData.rejected, (state, action) => {
        state.viewStageOneData.loading = false;
        state.viewStageOneData.error = action.payload || 'Failed to fetch stage one submitted data';
      })

      .addCase(fetchViewEwStageTwoData.pending, (state) => {
        state.viewStageTwoData.loading = true;
        state.viewStageTwoData.error = null;
      })
      .addCase(fetchViewEwStageTwoData.fulfilled, (state, action) => {
        state.viewStageTwoData.loading = false;
        state.viewStageTwoData.data = action.payload.data;
      })
      .addCase(fetchViewEwStageTwoData.rejected, (state, action) => {
        state.viewStageTwoData.loading = false;
        state.viewStageTwoData.error = action.payload || 'Failed to fetch stage two submitted data';
      })
      .addCase(fetchEndWallFlowHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEndWallFlowHistory.fulfilled, (state, action) => {
        state.flowHistory = action.payload.data || [];
      })
      .addCase(fetchEndWallFlowHistory.rejected, (state, action) => {
        state.loading = false;
        state.flowHistory = action.payload.data;
      })
      .addCase(endWallActionStageOne.pending, (state) => {
        state.loading = true;
      })
      .addCase(endWallActionStageOne.fulfilled, (state, action) => {
        state.loading = false;
        state.actionStageOne = action.payload.data;
      })
      .addCase(endWallActionStageOne.rejected, (state, action) => {
        state.loading = false;
        state.actionStageOne = action.payload.data;
      })
      .addCase(fetchEwMasterNumbers.pending, (state) => {
        state.getMasterEwNo.loading = true;
        state.getMasterEwNo.error = null;
      })
      .addCase(fetchEwMasterNumbers.fulfilled, (state, action) => {
        state.getMasterEwNo.loading = false;
        state.getMasterEwNo.ew_nos = action.payload.data;
      })
      .addCase(fetchEwMasterNumbers.rejected, (state, action) => {
        state.getMasterEwNo.loading = false;
        state.getMasterEwNo.error = action.payload || 'Failed to fetch master ew types';
      })
       .addCase(fetchNewEndWallFlowHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNewEndWallFlowHistory.fulfilled, (state, action) => {
        state.flowEndWallHistory = action.payload.data || [];
      })
      .addCase(fetchNewEndWallFlowHistory.rejected, (state, action) => {
        state.loading = false;
        state.flowEndWallHistory = action.payload.data;
      });
  },
});

export default endWallSlice.reducer;
